let navigation = document.querySelectorAll('.change');
let banner = document.getElementById('banner__title');
let btnStatClose = document.querySelector('.change--stat');
const btnPhoneClose = document.querySelector('.change--phone');
let phone = document.querySelector('.nav__phone');
let arrow = document.querySelector('.arrow__phone');
let actifTitle;
let actifInfo;

navigation.forEach((button) => {

    phone.addEventListener('click', function (e) {
        phone.classList.add('nav__phone--actif');
    });

    arrow.addEventListener('click', function (e) {
        phone.classList.remove('nav__phone--actif');
    });

    button.addEventListener('click', (e) => {
        e.preventDefault();

        actifTitle = banner.innerHTML;
        actifInfo = document.body.getAttribute('data-page');

        let dataInfo = e.currentTarget.getAttribute('data-info');
        let dataName = e.currentTarget.getAttribute('data-name');

        if (dataInfo == 'stat') {

            btnStatClose.setAttribute('data-name', actifTitle);

            banner.innerHTML = dataName;
            document.body.setAttribute('data-stat', 'true');

            return;
        }

        if (dataInfo == 'phone') {

            btnPhoneClose.setAttribute('data-name', actifTitle);
            btnPhoneClose.setAttribute('data-info', actifInfo);

            document.body.setAttribute('data-page', dataInfo);

            banner.innerHTML = dataName;

            return;

        }

        if (dataInfo == 'close') {
            banner.innerHTML = dataName;
            document.body.setAttribute('data-stat', 'false');

            return;
        }

        document.body.setAttribute('data-page', dataInfo);
        banner.innerHTML = dataName;
    });

});


/* Diagramme 
   Source : https://developers.google.com/chart/    
*/

google.charts.load('current', {
    'packages': ['corechart']
});
google.charts.setOnLoadCallback(drawChart);

function drawChart() {

    var data = google.visualization.arrayToDataTable([
          ['Accidents domestiques', 'Nombre de morts'],
          ['Noyade', 72],
          ['Asphyxie', 46],
          ['Brûlure', 22],
          ['Chute', 19],
          ['Intoxication', 3],
          ['Autres', 59]
        ]);

    var options = {
        title: '',
        width: '100%',
        height: '500px',
        colors: ['#3E8EDD', '#C45363', '#EA7E34', '#FFA562', '#81CF84', '#ccc'],
        legend: {
            position: "right",
            alignment: "center"
        },
        chartArea: {
            left: '10',
            width: '130%',
            height: '65%'
        },
    };

    var chart = new google.visualization.PieChart(document.getElementById('piechart'));

    chart.draw(data, options);

    window.addEventListener('resize', function () {
        chart.draw(data, options)
    });
}